function formatCents(cents) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  const amount = (Number(cents) / 100).toFixed(2);
  const [dollars, centsPart] = amount.split('.');
  const formatted = dollars.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') + '.' + centsPart;
  return formatted;
}

const money = () => {
  // $money magic — kept for any inline usage
  Alpine.magic('money', () => {
    return (cents, format) => {
      if (format) format = '${{' + format + '}}';
      const value = formatCents(cents);
      const formatString = format || '${{amount}}';
      return formatString.replace(/\{\{\s*\w+\s*\}\}/, value);
    };
  });

  // x-money directive — replaces alpinejs-money npm package
  // .shopify modifier: reads window.Shopify.currency.active and prepends "$", appends currency code
  // e.g. $54.00 USD or $54.00 CAD
  Alpine.directive('money', (el, { expression, modifiers }, { evaluateLater, effect }) => {
    const isShopify = modifiers.includes('shopify');
    const currency = isShopify ? (window?.Shopify?.currency?.active || '') : '';

    const getValue = evaluateLater(expression);

    effect(() => {
      getValue((cents) => {
        if (cents == null) return;
        const formatted = formatCents(cents);
        el.innerText = currency
          ? `$${formatted}` // ${currency}`
          : `$${formatted}`;
      });
    });
  });
};

export default money;
